<!-- eslint-disable ts/ban-ts-comment -->
<script setup lang='ts'>
import { APP_ROUTER } from '@qctsw/common'
import type { ComplaintDetailResponse } from '@/server/types'
import { genIssueRouteQuery } from '~/shared/function'

const props = withDefaults(defineProps<{
  type?: 'appeal' | 'issue'
  list: ComplaintDetailResponse['issueLs']
}>(), {
  type: 'issue',
  list: () => [],
})
</script>

<template>
  <div class="flex flex-wrap">
    <template v-if="props.type === 'issue'">
      <NuxtLink
        v-for="v, i in props.list"
        :key="i"
        :to="APP_ROUTER.complaintSearch(genIssueRouteQuery(v)) as any"
        class="mx-1.5 my-1 item-primary"
      >
        {{ v.label }}{{ v.fIssueLabel ? `-${v.fIssueLabel}` : '' }}{{ v.carPartsName ? `(${v.carPartsName})` : '' }}
      </NuxtLink>
    </template>
    <template v-else>
      <NuxtLink
        v-for="v, i in props.list" :key="i"
        :to="`/complaint/search?appeal=${v.issueId}`"
        class="hover:text-blue-5"
      >
        {{ v.label }}{{ i >= props.list.length - 1 ? '' : '、' }}
      </NuxtLink>
    </template>
  </div>
</template>

<style lang='scss' scoped>
.item-primary {
  --uno: inline-block border-1 border-blue-5 text-blue-5 rounded-full px-3 py-0.75 flex-shrink-0 whitespace-nowrap font-normal text-3.25;
}
</style>
